const CODE_VALUE_END_POINT = {
  CODE: "/kiban/api/code-value/code",
  AD_MEDIA: "/kiban/api/code-value/admedia",
} as const

export default CODE_VALUE_END_POINT
